<template>
  <div class="paintings">
    <navigation></navigation>
    <!-- Circle Preloader -->
    <h3>Fashion for Bornutti</h3>
    <div class="container">
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti1.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>The Bornutti Bag</i><br />
              Handmade and unique
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti2.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Mano di Dio</i><br />
              Charleston (USA)
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti3.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Mano di Dio</i><br />
              Charleston (USA)
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti4.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Mano di Dio</i><br />
              Washington, D.C. (USA)
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti5.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Arena</i><br />
              Amsterdam (NL)
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti6.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Biach</i><br />
              Galerie Holger John, Dresden (GER)
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti7.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Jacket</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti8.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Office</i><br />
              Dresden (GER)
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti9.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Militante</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti10.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti The Room</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti11.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Passione</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti12.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti your body</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti13.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Burka</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti14.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti, E. Ehrlich</i><br />
              Berlin (GER)
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti15.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Cabina</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti16.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Cabina</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti17.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti printing etiquettes</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti18.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti ready to ship</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti19.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Chain</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti20.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti testprint</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti21.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Bambini</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti22.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Biach</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti23.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti The Secret</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti24.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti The Favela Catsuit</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti25.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Arena</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti26.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Arena</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti27.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Sogno</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti28.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Onesto</i><br />
            </p>
          </div>
        </div>

        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti30.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Onesto 2</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti31.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right"><i>Bornutti Bus</i><br /></p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti32.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Onesto</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti33.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Tanktop</i><br />
              Cape Caneveral (USA)
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti34.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti Goldchain</i><br />
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/fashion/bornutti35.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Bornutti BORN 86</i><br />
            </p>
          </div>
        </div>
        <!-- end row 4 -->
      </div>
      <!-- -->
    </div>

    <!--container end div-->
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
